<template>
    <div class="error-license-lock">
        <div class="error-license-lock__header">
            <div class="error-license-lock__header-logo">
                <CompassLogo type="logo" :width="160" />
            </div>
        </div>

        <div class="error-license-lock__container">
            <template v-if="isDisplayed">
                <div class="error-license-lock__illustration">
                    <img src="/ressources/logged/img/errors/lock.svg" :width="210" :height="160" />
                </div>

                <div class="error-license-lock__content">
                    <h1 class="error-license-lock__title typographies-display-large">
                        {{ title }}
                    </h1>

                    <p class="error-license-lock__subtitle typographies-paragraph-x-large-regular">
                        <span v-for="(subtitle, index) in subtitles" :key="index">
                            {{ subtitle }}
                            <br v-if="index < subtitles.length - 1" />
                        </span>
                    </p>
                </div>
            </template>

            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true,
        },
        subtitles: {
            type: Array,
            default: () => {
                return [];
            },
        },
        isDisplayed: {
            type: Boolean,
            default: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.error-license-lock {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: var(--spacing-5);
    min-height: 100%;

    &__container {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        gap: var(--spacing-5);
        margin: auto;
    }

    &__content {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: var(--spacing-3);
    }

    &__title {
        color: var(--colors-common-text-brand-secondary-blue);
        margin: 0;
    }

    &__subtitle {
        color: var(--colors-common-text-subtle-default);
        text-align: center;
        margin: 0;
    }
}
</style>
